/*
  Afterpay's on-site messaging placement always prints the STORE's default currency
  symbol ($) - Afterpay confirmed this is a limitation on their side. The instalment
  amount itself is already in the market's currency, so on UK PDPs a GBP product ends
  up reading "4 payments of $57.25".

  Swaps the symbol inside the placement's (open) shadow root and keeps it swapped every
  time the widget re-renders - including when a Pumper quantity-break tier rewrites
  data-amount (see snippets/afterpay-app-blocks.liquid).

  No-op in the dollar markets (US/AU/CA), so it can be loaded unconditionally.
*/
(function () {
  var iso = window.Shopify && Shopify.currency && Shopify.currency.active;
  if (!iso) return;

  var symbol;
  try {
    symbol = (0).toLocaleString('en', { style: 'currency', currency: iso }).replace(/[\s\d.,]/g, '');
  } catch (e) {
    return;
  }
  if (!symbol || symbol.indexOf('$') > -1) return;

  var DOLLAR = /(?:US|A|CA|NZ)?\$/g;
  var SELECTOR = 'square-placement, afterpay-placement, square-modal, afterpay-modal';
  var watched = [];

  function swap(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('$') > -1) node.nodeValue = node.nodeValue.replace(DOLLAR, symbol);
    }
  }

  function watch() {
    var els = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < els.length; i++) {
      var root = els[i].shadowRoot;
      if (!root || watched.indexOf(root) > -1) continue;
      watched.push(root);

      (function (shadow) {
        new MutationObserver(function () {
          swap(shadow);
        }).observe(shadow, { childList: true, subtree: true, characterData: true });
        swap(shadow);
      })(root);
    }
  }

  // ponytail: the widget upgrades (and attaches its shadow root) long after DOMContentLoaded,
  // and shadow mutations don't bubble - so poll for placements instead of observing the document.
  var ticks = 0;
  var timer = setInterval(function () {
    watch();
    if (++ticks > 100) clearInterval(timer);
  }, 300);
  watch();
})();
